import React from 'react';
import { AirflowDagRun } from '../../types';
import { displayValue, formatDateTime, formatDurationSeconds } from '../../utils';
import { DetailRow } from '../../detail-row';
import styles from '../../styles.module.scss';

type DetailsTabProps = {
    run: AirflowDagRun | null;
    isLoading: boolean;
};

/*
 * DAG-run detail's Details tab — full key/value run metadata including pretty-printed conf
 */
export function DetailsTab({ run, isLoading }: DetailsTabProps) {
    if (isLoading || !run) return null;

    const hasConf = run.conf && Object.keys(run.conf).length > 0;

    return (
        <div className={styles.card}>
            <DetailRow label="Run ID">{run.dag_run_id}</DetailRow>
            <DetailRow label="DAG ID">{run.dag_id}</DetailRow>
            <DetailRow label="State">{run.state}</DetailRow>
            <DetailRow label="Run Type">{run.run_type}</DetailRow>
            <DetailRow label="Logical Date">{formatDateTime(run.execution_date ?? run.logical_date)}</DetailRow>
            <DetailRow label="Queued At">{formatDateTime(run.queued_at)}</DetailRow>
            <DetailRow label="Start Date">{formatDateTime(run.start_date)}</DetailRow>
            <DetailRow label="End Date">{formatDateTime(run.end_date)}</DetailRow>
            <DetailRow label="Duration">{formatDurationSeconds(run.duration)}</DetailRow>
            <DetailRow label="Data Interval Start">{formatDateTime(run.data_interval_start)}</DetailRow>
            <DetailRow label="Data Interval End">{formatDateTime(run.data_interval_end)}</DetailRow>
            <DetailRow label="Run After">{formatDateTime(run.execution_date ?? run.run_after)}</DetailRow>
            <DetailRow label="Last Scheduling Decision">{formatDateTime(run.last_scheduling_decision)}</DetailRow>
            <DetailRow label="Triggered By">{displayValue(run.triggered_by)}</DetailRow>
            <DetailRow label="Triggering User">{displayValue(run.triggering_user_name)}</DetailRow>
            <DetailRow label="Note">{displayValue(run.note)}</DetailRow>
            <DetailRow label="Conf">
                {hasConf ? <pre style={{ maxHeight: 200, overflow: 'auto', margin: 0 }}>{JSON.stringify(run.conf, null, 2)}</pre> : '—'}
            </DetailRow>
        </div>
    );
}
